import axios from '../../../axios'



// 获取列表
export const list = (data) => {
  return axios({
    url: '/confirm/inspection/list',
    method: 'post',
    data
  })
}

// 提交
export const confirm = (data) => {
  return axios({
    url: '/confirm/inspection/confirm',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/confirm/confirmInspection.js